import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import '../../../styles/main.css';
import CxToolbar from '../../cx/CxToolbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import GxLongTask from '../../gx/GxLongTask';


const MxSettStockTruncate = (props) => {
  const [{ trans }] = useTranslation();

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
  }

  return (
    <div>
      <CxToolbar moduleName={`${trans('field.stock_op_truncate')}`} />
      <GxLongTask />
    </div>
  );

}

export default MxSettStockTruncate;
